/**
 * Redirige vers la page /commander si accès à une autre étape du tunnel en SSR
 */


export default defineNuxtRouteMiddleware((route) => {

  if (process.client) {
    return;
  }
  return navigateTo({ path: "/commander", query: { type_panier: route.query.type_panier || "drive" } }, { replace: true });
})
